import { genericMap2LegacyTheme } from './genericMap2LegacyTheme';
import { genericMap2Tokens } from './genericMap2Tokens';
import { propAdapter } from './propAdapter';
const map = {
  regular: '--st-dt-text-weight-regular',
  // 400
  medium: '--st-dt-text-weight-medium',
  // 500
  bold: '--st-dt-text-weight-bold' // 700
};
export const map2Tokens = legacyThemeProperty => {
  return genericMap2Tokens(legacyThemeProperty, map);
};
export const map2LegacyTheme = (tokens, legacyThemeProperty) => {
  return genericMap2LegacyTheme(tokens, legacyThemeProperty, map);
};
export const fontWeightPropAdapter = propAdapter(map);